import { render, staticRenderFns } from "./FansList.vue?vue&type=template&id=f06b17fa&"
import script from "./FansList.vue?vue&type=script&lang=js&"
export * from "./FansList.vue?vue&type=script&lang=js&"
import style0 from "./FansList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports